// extracted by mini-css-extract-plugin
var _1 = "bpl__route-leaderboard__jp6Qc";
var _2 = "bpl__route-leaderboard__gifts__fKyFW";
var _3 = "bpl__route-leaderboard__gifts__title__Yzrtw";
var _4 = "bpl__route-leaderboard__subnavigation__rJ8d4";
export { _1 as "route-leaderboard", _2 as "route-leaderboard__gifts", _3 as "route-leaderboard__gifts__title", _4 as "route-leaderboard__subnavigation" }
